import { render, staticRenderFns } from "./Carts.vue?vue&type=template&id=5e965dfb"
import script from "./Carts.vue?vue&type=script&lang=js"
export * from "./Carts.vue?vue&type=script&lang=js"
import style0 from "./Carts.vue?vue&type=style&index=0&id=5e965dfb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports